















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import Heading from '@/shared/components/Heading/Heading.vue';

import { EModalType, EModalTransition, EDevice } from '@/helpers/enums';
import { deviceByBreakpoint } from '@/helpers/breakpoint';

@Component({
  inheritAttrs: true,
  components: {
    Heading,
  },
})
export default class Modal extends Vue {
  @Prop()
  private readonly type?: EModalType;

  @Prop({ default: () => 'center center' })
  private readonly origin?: string;

  @Prop({ default: true })
  private readonly persistent?: boolean;

  @Prop()
  private readonly transition?: EModalTransition;

  @Prop()
  private readonly extraClass?: string;

  @Prop({ default: 425 })
  private readonly width?: number;

  @Prop({ default: true })
  private readonly visibility: boolean;

  @Prop({ default: false })
  private readonly showSecurity: boolean;

  @Prop()
  private readonly backAction?: Function;

  @Prop()
  private readonly closeAction?: Function;

  private get transitionByDevice() {
    if (!this.transition) {
      if (this.deviceIsMobile) {
        return EModalTransition.bottom;
      } else {
        return EModalTransition.default;
      }
    }

    return this.transition;
  }

  private get canShowSecurity () {
    return this.$route.query.s === '1' && this.showSecurity;
  }

  private get deviceIsMobile() {
    return deviceByBreakpoint(this.$vuetify.breakpoint.name) === EDevice.mobile;
  }
}
